import { FindBreak } from "./FindBreak";

export function BreakCommon(theContent, re, availableWidth, fontString, maxRows, rowList) {
  var done = false;
  while (!done) {
    var rowContent = FindBreak(theContent, availableWidth, fontString, re);
    if (rowContent.length == 0) done = true;
    else {
      rowList.push(rowContent);
      //if (typeof(theContent) != "string")
      //	console.log("hello");
      //theContent = theContent.toString();
      theContent = theContent.substring(rowContent.length, theContent.length);
      if (rowList.length >= maxRows) done = true;
    }
  }

  if (rowList.length == 0) rowList.push(theContent);
}
